import apiCrud from '../../abstract/api-crud';
import apiPaths from '../../../../api-v2/api-paths';

const baseUri = `${ apiPaths.CRM }/crm-mails`;
export const modelName = 'mail';

export default {
  ...apiCrud({ baseUri, modelName }),
};
